import { render, staticRenderFns } from "./bannerC.vue?vue&type=template&id=2b2d1ec0"
import script from "./bannerC.vue?vue&type=script&lang=js"
export * from "./bannerC.vue?vue&type=script&lang=js"
import style0 from "./bannerC.vue?vue&type=style&index=0&id=2b2d1ec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports